<script>
export default {
    name: "RadiologyPrint",

    data() {

        return {
            patient: {},
            investigations: [],
            printTime: window.moment(),
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ 
                this.fetchPatient(), this.fetchInvestigations(), 
            ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => {this.$root.loading = false;});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchInvestigations() {
            let url = `MedicalFile/GetPatientRadiologyInvestigationTreatment`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.investigations = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap p-tiny">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
        <div class="w-1/3">
            <h5 class="text-base">
                <span class="font-medium">Name:</span> {{ patient.names }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="text-base">
                <span class="font-medium">Visit No:</span> {{ patient.visitNo || `-` }}</h5>
        </div>
        <div class="flex-1">
            <h5 class="text-base">
                <span class="font-medium">MRN:</span> {{ patient.patienT_ID }}</h5>
        </div>
    </div>
    <div class="w-full p-tiny">
        <table class="table">
            <thead class="text-xs">
                <tr class="w-full flex">
                    <th class="p-tiny flex-1">Id</th>
                    <th class="p-tiny w-1/4">Item</th>
                    <th class="p-tiny flex-1">Req By</th>
                    <th class="p-tiny flex-1">Done</th>
                    <th class="p-tiny flex-1">Urgent</th>
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Progress</th>
                    <th class="p-tiny flex-1">Action</th>
                </tr>
            </thead>
            <tbody
                class="text-xs bg-gray-100 flex flex-col items-center">
                <tr class="w-full flex" v-for="(inv, idx) in investigations" :key="idx">
                    <td class="p-tiny flex-1">{{ inv.code }}</td>
                    <td class="p-tiny w-1/4">{{ inv.investigation }}</td>
                    <td class="p-tiny flex-1">{{ inv.requestedBy || inv.userName }}</td>
                    <td class="p-tiny flex-1">{{ inv.done ? `Yes` : `No` }}</td>
                    <td class="p-tiny flex-1">{{ inv.isUrgent ? `Yes` : `No` }}</td>
                    <td class="p-tiny flex-1">{{ inv.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ inv.progress }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
